import { useTranslations } from "next-intl";
import NexusProductResult from "./NexusProductResult";
import { NexusProduct } from "@/types/nexus-product";

const Results = (props: any) => {
  const {
    setSearchModalOpen,
    filterValue,
    products,
    searchTerm,
    host,
  } = props;

  const t = useTranslations("SearchNav");

  return (
    <div className="w-full px-4">
      {(filterValue === "all" || filterValue === "products") && (
        <>
          <h2 className="mb-4 text-xl text-dark font-bold">
            {t("searchedProducts")}
          </h2>

          {!searchTerm || searchTerm.length < 2 ? (
            <div className="text-center py-10 text-gray-6">
              <p>{t("minCharactersPrompt")}</p>
            </div>
          ) : products.length === 0 ? (
            <div className="text-center py-10 text-gray-6">
              <p>
                {t("noProductsFound")} "{searchTerm}"
              </p>
            </div>
          ) : (
            <div className="grid gap-3">
              {products.map((product: NexusProduct) => (
                <NexusProductResult
                  key={product.id}
                  product={product}
                  setSearchModalOpen={setSearchModalOpen}
                  host={host}
                />
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Results;
